import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from "react-redux";
// import { Link, useParams } from 'react-router-dom';
import { getTranslations } from "./../../../store/localization/selectors";
// import { getUser } from "./../../../store/auth/selectors";
import { getLayout } from "./../../../store/settings/selectors";
import {useTheme} from "./../../../themes";

import {LAYOUT_XS, LAYOUT_SM} from './../../../settings';

// import MenuItem from "./../../../components/App/MenuItem";
import Icon from "./../../../components/App/Icon";
import Spacer from './../../../components/App/Spacer';


const Wrapper  = styled.div`
  position: relative;

  ${props => props.layout !== LAYOUT_XS && props.layout !== LAYOUT_SM ? `
    padding-left: 50%;
    padding-top: 20px;
  ` : `
    background-color: #fff;
    width:100%;
    padding: 5px 0px;
  `};

`;
const Container = styled.div`
  ${props => props.layout !== LAYOUT_XS && props.layout !== LAYOUT_SM ? `
    width: calc(100% - 30px);
    margin: 0px 15px;
  ` : `

  `};
`;
// const Menu = styled.div`
//   ${props => props.layout !== LAYOUT_XS && props.layout !== LAYOUT_SM ? `
//   ` : `
//     display: flex;
//     flex-direction: column;
//     overflow: hidden;
//     text-align: center;
//     padding-top: 5px;
//   ` + (props.isOpen ? `
//       height: auto;
//   ` : `
//       height: 0px;
//   `)};
// `;
// const Dot = styled.div`
//   width: 8px;
//   height: 8px;
//   background-color: ${props => props.color};
// `;
// const Void = styled.div`
//   width: 8px;
//   height: 8px;
// `;

const Toggler = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 5px 14px 0px;
  font-size: 12px;
  font-weight: 600;
  color: #000000;
`;


export default function Sidebar({selected}) {
  const theme = useTheme();
  // const lang = useSelector(getLocale);
  const translations = useSelector(getTranslations);
  // const user = useSelector(getUser);
  const layout = useSelector(getLayout);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper layout={layout}>
      { layout !== LAYOUT_XS && layout !== LAYOUT_SM ?
        <Spacer size={{value: 105, unit: "px"}} />
      : <Toggler onClick={() => setIsOpen(!isOpen) }><Icon color={"#000000"} name={theme.icons.set.menu} size={{value: 20, unit: "px"}} /> &nbsp; {translations["UI"]["_home-menu"]}</Toggler> }
      <Container layout={layout}>
        {/*<Menu layout={layout} isOpen={isOpen}>
          <Link to={"/"+lang}>
            <MenuItem
              onClick={() => {}}
              isActive={selected === "homepage"}
              leftIcon={selected === "homepage" ? <Dot /> : <Void />}
              variant={theme.homepage.menuitemVariant}
              size={theme.homepage.menuitemSize}
            >{translations["UI"]["_homepage-section-homepage"]}</MenuItem>
          </Link>
        </Menu>*/}
      </Container>
    </Wrapper>
  )
};
